<template>
    <div
            class="d-flex align-items-center justify-content-between border-top p-1 m-1 cursor--pointer"
            @click="$emit('click', user)"
    >
        <div
                class="d-flex align-items-center"
        >
            <b-img
                    :src="$store.getters['base/account/getAvatar'](user)"
                    width="25px"
                    height="25px"
                    alt="Avatar"
                    rounded="circle"
                    class="mr-2"
            />
            <h5 class="my-0">{{$store.getters['base/account/getFullName'](user)}}</h5>
        </div>
        <b-btn
                variant="link"
                v-if="multiple"
        >
            <i
                    class="fas"
                    :class="isSelected ? 'fa-minus': 'fa-plus'"
            />
        </b-btn>
    </div>
</template>
<script>
    export default {
        name: 'user-detail',
        props: {
            user: Object,
            multiple: {
                type: Boolean,
                default: false
            },
            isSelected: Boolean
        }
    }
</script>
